// extracted by mini-css-extract-plugin
export var menuIcon = "_t0-0";
export var menuIconInline = "_t0-1";